import { IndeterminateProgressCircle } from '@sunwebgroup/uds-ui/IndeterminateProgressCircle'
import { StillSkeleton } from '@sunwebgroup/uds-ui/skeleton'
import * as React from 'react'
import {
  filtersAreBeingApplied,
  useCarRentalFilteringServiceStore,
} from '@/scopes/checkout/components/services/CarRentalFilteringService/store'
import { useFilterableCarsAvailable } from '@/scopes/checkout/filterableCars/domain/hooks'
import styles from './FilterableCarsSkeleton.module.css'

export function FilterableCarsSkeleton() {
  const { isFetching } = useFilterableCarsAvailable()
  const isFetchingFilteredCars = useCarRentalFilteringServiceStore(filtersAreBeingApplied)

  if (!isFetchingFilteredCars || !isFetching)
    return null

  return (
    <div className={styles.skeletonCardListWrapper}>
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </div>
  )
}

function SkeletonCard() {
  return (
    <div className={styles.skeletonCardWrapper}>
      <DelayedSpinner delay={1000} />
      <div className={styles.skeletonCardContent}>
        <div className={styles.skeletonHeader} />
        <div className={styles.skeletonLeftContent} />
        <StillSkeleton className={styles.skeletonRightContent} />
      </div>
    </div>
  )
}

function DelayedSpinner({ delay }: { delay: number }) {
  const [show, setShow] = React.useState(false)

  React.useEffect(() => {
    const timer = setTimeout(() => setShow(true), delay)
    return () => clearTimeout(timer)
  }, [delay])

  return show ? <div className={styles.spinnerWrapper}><IndeterminateProgressCircle /></div> : null
}
